export const isInvoiceNotification = (type?: string): boolean => {
  if (!type) {
    return false;
  }
  return type.toUpperCase().startsWith('INVOICE_STATUS');
};

export const isSubscriptionNotification = (type?: string): boolean => {
  if (!type) {
    return false;
  }
  return type.toUpperCase().startsWith('SUBSCRIPTION_EVENT');
};

export const formatAutoRenewing = (value?: boolean | null): string => {
  if (value === true) {
    return 'On';
  }
  if (value === false) {
    return 'Off';
  }
  return 'N/A';
};
